import { formatDuration, formatTimestamp, zoneColors } from "./utils";

const ZonePath = ({ journeys }) => {
  if (!journeys?.length) return null;

  return (
    <div className="reid-zone-path">
      <div className="reid-zone-path-container">
        {journeys.map((journey, idx) => (
          <div key={idx} className="reid-zone-path-item">
            <div
              className="reid-zone-badge"
              style={{
                backgroundColor:
                  zoneColors[journey.zone_name] || zoneColors.default,
              }}
              title={`${journey.zone_name} - ${formatDuration(
                journey.dwell_time
              )} at ${formatTimestamp(journey.timestamp)}`}
            >
              <span className="reid-zone-badge-name">{journey.zone_name}</span>
              <span className="reid-zone-badge-time">
                ({formatDuration(journey.dwell_time)})
              </span>
            </div>
            {idx < journeys.length - 1 && (
              <div className="reid-zone-arrow">→</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ZonePath;
